import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const navLinks = [
  { label: "Inicio", path: "/" },
  { label: "Catálogo", path: "/catalogo" },
  { label: "Oportunidad", path: "/oportunidad" },
  { label: "Contacto", path: "/contacto" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header data-testid="main-navbar" className="glass-nav sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20 md:h-24">
          <Link to="/" className="flex items-center group" data-testid="logo-link">
            <img
              src="/logo-oymer-real.png"
              alt="Oymer - Distribuidor Autorizado Vida Divina"
              className="h-16 md:h-20 w-auto object-contain transition-transform duration-300 group-hover:scale-105"
            />
          </Link>

          <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.path.replace("/", "") || "home"}`}
                className={`font-body text-sm font-medium tracking-wide transition-colors duration-200 hover:text-forest ${
                  location.pathname === link.path ? "text-forest" : "text-sage"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/catalogo"
              data-testid="nav-cta-button"
              className="bg-forest text-white rounded-full px-6 py-2.5 text-sm font-body font-medium transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_10px_20px_rgba(42,74,60,0.15)]"
            >
              Ver Productos
            </Link>
          </nav>

          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden p-2 text-forest"
            onClick={() => setOpen(!open)}
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-white/95 backdrop-blur-xl border-t border-sand-dark px-6 py-6 space-y-4 animate-fade-in">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setOpen(false)}
              className={`block font-body text-base font-medium py-2 ${
                location.pathname === link.path ? "text-forest" : "text-sage"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/catalogo"
            onClick={() => setOpen(false)}
            className="block bg-forest text-white rounded-full px-6 py-3 text-center text-sm font-body font-medium"
          >
            Ver Productos
          </Link>
        </div>
      )}
    </header>
  );
}
